export default "__VITE_ASSET__C_4pt5NL__"